var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message meta-post-message" }, [
    _vm.getMetaText()
      ? _c("div", { staticClass: "meta-header" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
          _vm._v("\n        " + _vm._s(_vm.getMetaText()) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _vm.isImage()
        ? _c(
            "div",
            {
              staticClass: "image-post",
              on: {
                mouseenter: function ($event) {
                  _vm.hovered = true
                },
                mouseleave: function ($event) {
                  _vm.hovered = false
                },
              },
            },
            [
              _vm.imageSrc()
                ? _c(
                    "viewer",
                    {
                      attrs: {
                        id: "imageViewer-" + _vm.getId(),
                        images: [_vm.imageSrc()],
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end' }",
                            },
                          ],
                          staticClass: "cb-img-preview",
                          attrs: { content: _vm.$t("chatbotv2.imageView") },
                          on: { click: _vm.show },
                        },
                        [
                          _c("img", {
                            staticClass:
                              "img-thumbnail ant-upload-list-picture-card-container",
                            staticStyle: { "object-fit": "cover" },
                            attrs: {
                              id: "img-" + _vm.getId(),
                              src: _vm.imageSrc(),
                            },
                          }),
                          _vm._v(" "),
                          _vm.hovered
                            ? _c("md-icon", { staticClass: "cb-pr-icon" }, [
                                _vm._v(" visibility"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm.isVideo()
        ? _c("div", { staticClass: "video-post" }, [
            _c(
              "video",
              {
                staticClass: "video-player",
                attrs: {
                  controls: "",
                  preload: "metadata",
                  src: _vm.videoSrc(),
                  poster: _vm.getVideoPoster(),
                },
              },
              [
                _c("source", {
                  attrs: { src: _vm.videoSrc(), type: "video/mp4" },
                }),
                _vm._v(
                  "\n                Your browser does not support the video tag.\n            "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.getPostContent().length > 0
      ? _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "bottom-end" },
                expression: "{ followCursor: true, placement: 'bottom-end' }",
              },
            ],
            staticClass: "caption",
            attrs: { content: _vm.getPostContent() },
          },
          [_vm._v("\n        " + _vm._s(_vm.getPostContent()) + "\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isSendDM()
      ? _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "count-stats" }, [
            _c("span", { staticClass: "count-stat-item" }, [
              _vm._v(_vm._s(_vm.meta.likeCount) + " "),
              _c("i", { staticClass: "material-icons" }, [_vm._v("thumb_up")]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "count-stat-item" }, [
              _vm._v(_vm._s(_vm.meta.commentCount) + " "),
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("chat_bubble"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.meta.timestamp))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }